import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import { fetchBrandingConfig } from '../slices/thunks';
import { setConfig } from '../slices/brandingConfiguration/reducer';
import { CacheService } from '../services/cache';
import { CacheConfig } from '../services/cache/CacheConfig';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
// import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';

import { changeSidebarVisibility } from '../slices/thunks';
import type { RootState } from '../slices';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('layout_header');

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass } : any) => {
    const dispatch : any = useDispatch();

    // Branding config selector
    const selectBrandingState = (state: any) => state.BrandingConfiguration;
    const brandingData = createSelector(
        selectBrandingState,
        (state) => ({
            config: state.config,
            loading: state.loading,
        })
    );
    const { config: brandingConfig } = useSelector(brandingData);

    // Logo tuỳ chỉnh (upload) không có tỉ lệ cố định như ảnh mặc định của template,
    // nên cần kích thước rộng rãi hơn (22px/17px) để không bị hiển thị quá bé.
    const brandLogoSmStyle: React.CSSProperties = { height: 34, maxWidth: 34, width: 'auto', objectFit: 'contain' };
    const brandLogoLgStyle: React.CSSProperties = { height: 42, maxWidth: 160, width: 'auto', objectFit: 'contain' };


    const selectDashboardData = createSelector(
        (state: RootState) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
      );
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);
    

        /**
     * Effect: Load branding config với cache support
     * Tương tự Login.tsx - check cache trước, fetch nếu cần
     */
    useEffect(() => {
        const loadBrandingConfig = async () => {
            const cacheKey = CacheConfig.BRANDING.key;
            const cacheTtl = CacheConfig.BRANDING.ttl;
            
            // Check cache trước
            const cached = CacheService.get(cacheKey);
            
            if (cached.cached && cached.data) {
                console.log('[Header] Using cached branding config', cached.data);
                // IMPORTANT: Dispatch setConfig để update Redux state từ cache
                dispatch(setConfig(cached.data));
            } else {
                console.log('[Header] Fetching branding config from API');
                // Fetch từ API
                const result = await dispatch(fetchBrandingConfig());
                
                // Lưu vào cache nếu fetch thành công
                if (result.payload) {
                    CacheService.set(cacheKey, result.payload, cacheTtl);
                    console.log('[Header] Branding config cached');
                }
            }
        };
        
        loadBrandingConfig();
    }, [dispatch]);

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767)
            humberIcon.classList.toggle('open');

        //For collapse horizontal menu
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
        }

        //For collapse vertical and semibox menu
        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }


        //Two column menu
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">

                            <div className="navbar-brand-box horizontal-logo">
                                                                <Link to="/" className="logo logo-dark">
                                    <span className="logo-sm">
                                        <img
                                            src={brandingConfig?.logoUrl || logoSm}
                                            alt={st('logo_alt')}
                                            height="22"
                                            style={brandingConfig?.logoUrl ? brandLogoSmStyle : undefined}
                                        />
                                    </span>
                                    <span className="logo-lg">
                                        <img
                                            src={brandingConfig?.logoUrl || logoDark}
                                            alt={st('logo_alt')}
                                            height="17"
                                            style={brandingConfig?.logoUrl ? brandLogoLgStyle : undefined}
                                        />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light">
                                    <span className="logo-sm">
                                        <img
                                            src={brandingConfig?.logoUrl || logoSm}
                                            alt={st('logo_alt')}
                                            height="22"
                                            style={brandingConfig?.logoUrl ? brandLogoSmStyle : undefined}
                                        />
                                    </span>
                                    <span className="logo-lg">
                                        <img
                                            src={brandingConfig?.logoUrl || logoLight}
                                            alt={st('logo_alt')}
                                            height="17"
                                            style={brandingConfig?.logoUrl ? brandLogoLgStyle : undefined}
                                        />
                                    </span>
                                </Link>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>


                        </div>

                        <div className="d-flex align-items-center">

                            {/* LanguageDropdown */}
                            {/* <LanguageDropdown /> */}

                            {/* WebAppsDropdown */}
                            {/* <WebAppsDropdown /> */}

                            {/* MyCartDropdwon */}
                            {/* <MyCartDropdown /> */}

                            {/* FullScreenDropdown */}
                            {/* <FullScreenDropdown /> */}

                            {/* Dark/Light Mode set */}
                            <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            />

                            {/* NotificationDropdown */}
                            <NotificationDropdown />

                            {/* ProfileDropdown */}
                            {/* <ProfileDropdown /> */}
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
